import React from 'react';
import { Tabs } from 'antd';

import { IMetalGroup } from '../../../../sharedInterfaces';
import { RadioGroup, TabSelect, isMobile, PurityDropdown, isLowHeight, Dropdown } from "../../ui-helpers";

import {
  Image,
  OptionItem,
  RadioGroupWrapper,
  OptionsContainer,
  SectionTitle,
  StyledTabTitle,
  TabContent,
  MaterialWrapper,
  MenuSection as MenuSection
} from './Materials-styled';
import { theme } from '../../../../styles';

import { TabContainer } from '../Tab-style';


interface Props {
  metalGroups: IMetalGroup[],
  onMetalGroupChange: (value: IMetalGroup) => void,
  limitedMaterials: string[],
  currentMenuMetalGroup: IMetalGroup,
  onCurrentMenuMetalGroupChange: (setTo: string) => void,
  assetURI: string
}

interface State {

}


export default class extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  };

  onParameterChange = (group: string, param: 'material' | 'surface' | 'purity', value: any) => {
    //console.log('onParameterChange()', group, param, value);

    const { metalGroups } = this.props;
    const editedMetalGroup = metalGroups.find(({ name }) => name === group);

    this.props.onMetalGroupChange({
      ...editedMetalGroup,
      [param]: value,
    });
  };

  render = () => {
    const {
      metalGroups,
      currentMenuMetalGroup,
      limitedMaterials,
      onCurrentMenuMetalGroupChange,
      assetURI
    } = this.props;

    if (!currentMenuMetalGroup) return null;

    return (
      <TabContainer className="threed-configurator-menu-materials-tab">
        {
          metalGroups.map((m, index) => {
            const defaultMaterial = m.materialOptions.find((o)=> o == m.material);
            const defaultSurface = m.surfaceOptions.find((o)=> o == m.surface);
            return <div key={index}>
              <StyledTabTitle>Material {index + 1}</StyledTabTitle>
              <TabContent isLastItem={index == metalGroups.length - 1}>
                <MaterialWrapper>
                  <Dropdown
                    title=""
                    width={150}
                    opacity={1}
                    defaultOption={m.material}
                    defaultImage={`${assetURI}/images/materials/${defaultMaterial} ${m.surface}.png`}
                    options={
                      m.materialOptions.map((r) => ({
                        value: r,
                        label: r,
                        image: `${assetURI}/images/materials/${r} ${m.surface}.png`
                      }))
                    }
                    onChange={(value) => {
                      this.onParameterChange(m.name, 'material', value)
                    }}
                  />
                  {
                    m.purityOptions?.length > 0 && <PurityDropdown
                      defaultOption={m.purity}
                      options={m.purityOptions}
                      onChange={(value) => {
                        this.onParameterChange(m.name, 'purity', value)
                      }}
                    />
                  }
                </MaterialWrapper>   
                <MaterialWrapper>
                  <Dropdown
                    title=""
                    width={150}
                    opacity={1}
                    defaultOption={m.surface}
                    defaultImage={`${assetURI}/images/materials/${m.material} ${defaultSurface}.png`}
                    options={
                      m.surfaceOptions.map((r) => ({
                        value: r,
                        label: r,
                        image: `${assetURI}/images/materials/${m.material} ${r}.png`
                      }))
                    }
                    onChange={(value) => {
                      this.onParameterChange(m.name, 'surface', value)
                    }}
                  />
                </MaterialWrapper>      
              </TabContent>
            </div>
          })
        }
      </TabContainer>
    )
  };
};